module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "p2bkmk2"
    }
  }), _vm._v(" F"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("OR")]), _vm._v(" E"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("UGENE")]), _vm._v(" M. W"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("AITH")])])]), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("A GENTLEMAN")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("A SCHOLAR")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("A REAL MAN")]), _c('br'), _vm._v("\n1912–2007")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0231ff64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 66
// module chunks = 0